import { InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';

/** Values sent as `appEnvironment` (lower case, no "_"). */
export type AppEnvironment = 'local' | 'dev' | 'prod';

/** `mixpanel` block of the environment files. */
export interface MixpanelEnvironmentConfig {
  token: string;
  enableReplay: boolean;
  replayPercent: number;
  optOutUrl: string;
}

export interface MixpanelSettings extends MixpanelEnvironmentConfig {
  appEnvironment: AppEnvironment;
}

/** Maps the environment flags to the `appEnvironment` base property. */
export function resolveAppEnvironment(env: { isLocal: boolean; production: boolean }): AppEnvironment {
  if (env.isLocal) return 'local';
  return env.production ? 'prod' : 'dev';
}

/** Mixpanel settings for the current build. Specs provide their own value. */
export const MIXPANEL_CONFIG = new InjectionToken<MixpanelSettings>('MIXPANEL_CONFIG', {
  providedIn: 'root',
  factory: () => ({ ...environment.mixpanel, appEnvironment: resolveAppEnvironment(environment) }),
});
